import React from 'react';
import { makeStyles } from '@mui/styles';
import DialogContent from '@mui/material/DialogContent';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const useStyles = makeStyles({
    dialogContentMain: {
        background: "#FBFBF5",
    },
});

export const MailProDialogBody = ({ children, className, ...rest }) => {
    const classes = useStyles();
    return (
        <DialogContent
            className={classNames(classes.dialogContentMain, className)}
            {...rest}
        >
            {children}
        </DialogContent>
    );
}


MailProDialogBody.propTypes = {
    children: PropTypes.node,
};